import { AnimatePresence, motion } from "motion/react";

import { cn } from "@/lib/utils";

interface AnimatedScoreProps {
  value: string | number | null | undefined;
  suffix?: string;
  fallback?: string;
  className?: string;
}

export const AnimatedNumber = ({
  value,
  suffix,
  fallback = "-",
  className,
}: AnimatedScoreProps) => {
  // `??`, not `||`: a legitimate `0` (no winners left) must render as "0", not as the fallback.
  const display = value ?? fallback;
  return (
    <div className={cn("inline-flex items-baseline", className)}>
      <span className="relative inline-block overflow-hidden leading-normal tabular-nums">
        {/* Invisible sizer locks the animated layer's width to the current value
            so AnimatePresence transitions never push the parent. */}
        <span aria-hidden className="invisible">
          {display}
        </span>
        <AnimatePresence mode="popLayout" initial={false}>
          <motion.span
            key={String(display)}
            initial={{ y: "40%", opacity: 0, scale: 0.8 }}
            animate={{ y: 0, opacity: 1, scale: 1 }}
            exit={{ y: "-40%", opacity: 0 }}
            className="absolute inset-0 inline-block"
          >
            {display}
          </motion.span>
        </AnimatePresence>
      </span>
      {suffix && <span className="ml-1">{suffix}</span>}
    </div>
  );
};
